import Button from '../Button';
import Image from '../Image';
import KoreaCooperationLayerPopup from '../Layer/KoreaCooperationLayerPopup';
import LinkSafe from '../LinkSafe';
import SwiperBasic from '../Swiper/SwiperBasic';
import { Tit } from '../Titles';
import NullImage1 from '@/assets/img/tmp/no_img1@2x.png';
import NullImage2 from '@/assets/img/tmp/no_img2@2x.png';
import { breakpoint } from '@/helpers/BreakpointHelper';
import dayjs from 'dayjs';
import React, { FC, ImgHTMLAttributes, useState } from 'react';
import styled from 'styled-components';
import SwiperCore, { A11y, Navigation, Scrollbar, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

SwiperCore.use([Navigation, Scrollbar, A11y, Autoplay]);

interface NewsProps {
  newslist: NewsData[];
  isSwiper?: boolean;
  isDate?: boolean;
  img?: boolean;
  motion?: boolean;
  btn?: boolean;
  pop?: boolean;
  popInnerTit?: string;
}

export interface NewsData {
  id?: string | number;
  pcImage?: ImgHTMLAttributes<any>['src'];
  mobileImage?: ImgHTMLAttributes<any>['src'];
  title?: string | undefined;
  link?: string;
  date?: string | number;
  popTit?: string;
  popSid?: number;
  video?: string;
  contents?: string;
  imgYn?: string;
  boardCategoryCode?: string;
}
const NewsImage = styled.div<NewsProps>`
  overflow: hidden;
  position: relative;

  .img-box {
    width: 100%;
    padding-top: 100%;
  }

  .card-img {
    max-width: 100%;
    width: 100%;
  }

  .img-box,
  .card-img {
    transition: transform 1.2s;
  }
  &::before {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    z-index: 1;
    border: 0px solid transparent;
    transition: border 0.2s;
  }

  .link-item {
    display: block;
  }

  /* if motion 경우 (최근소식 모션 없음) */
  &:hover {
    .img-box,
    .card-img {
      ${({ motion }) => {
        if (motion) {
          return `transform: translate(-50%, -50%) scale(1.2);`;
        }
        return ``;
      }}
    }
    &::before {
      ${({ motion }) => {
        if (motion) {
          return `border: 8px solid #1cabe2;`;
        }
        return ``;
      }}
    }
  }
`;
const NewsBody = styled.div`
  background: #fff;
  padding-top: 32px;

  strong {
    line-height: 1.6;
    min-height: 64px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: #2d2926;
    text-align: left;
    word-break: break-all;
  }

  ${breakpoint(`tablet`)} {
    padding-top: 16px;
    strong {
      min-height: 50px;
    }
  }
`;
const NewsDate = styled.span`
  display: block;
  margin-top: 16px;
`;
const NewText = styled.span`
  font-size: 14px;
  color: #1cabe2;
  font-weight: normal;
  display: inline-block;
  margin: -2px 0 0 8px;
  vertical-align: middle;
`;
const LinkButton = styled(Button)`
  display: block;
  border: 0;
  height: auto;
  background-color: transparent;
  padding: 0;
`;
const NewsCardLayout = styled.ul`
  & > li {
    width: 25%;

    ${NewsImage} {
      background: url(${NullImage1}) center no-repeat;
      background-size: cover;

      .img-box {
        padding-top: 100%;
        height: 0;
      }
    }

    &:nth-child(2n + 0) {
      ${NewsImage} {
        background-image: url(${NullImage2});
      }
    }
  }

  ${breakpoint(`tablet`)} {
    margin: 0 -12px;
    li {
      padding: 0 12px;
      width: 33.33%;
    }
  }
  ${breakpoint(`mobile`)} {
    li {
      width: 50%;
    }
  }
`;
const SwiperCustom = styled(SwiperBasic)<NewsProps>`
  padding: 0;

  .swiper-container {
    padding-bottom: 83px;
    width: auto;
    position: relative;
    margin: 0 -16px;

    ${({ btn }) => `padding-bottom: 117px;`}
  }
  .swiper-scrollbar {
    max-width: 100%;
    width: auto;
    left: 16px;
    right: 16px;
    margin-left: 0;
    bottom: 0;
    transform: translate(0, 0);

    ${({ btn }) => `
      right: 218px; 
      bottom: 36px;
    `}
  }

  .swiper-button-prev,
  .swiper-button-next {
    display: none;
    bottom: 10px;
    margin: 0;
    ${({ btn }) => `display: block;`}
  }
  .swiper-button-prev {
    right: 96px;
  }
  .swiper-button-next {
    right: 16px;
  }

  .swiper-slide {
    overflow: hidden;
    padding: 0 16px;
    width: 25%;

    ${NewsImage} {
      background: url(${NullImage1}) center no-repeat;
      background-size: cover;
    }
    .link-item {
      display: block;
      width: 100%;
    }

    &:nth-child(2n + 0) {
      ${NewsImage} {
        background-image: url(${NullImage2});
      }
    }
  }

  ${breakpoint(`tablet`)} {
    .swiper-container {
      padding-bottom: 40px;
      margin: 0 -12px;
    }

    .swiper-slide {
      width: 33.33%;
      padding: 0 12px;
    }
    .swiper-scrollbar {
      left: 12px;
      right: 12px;
    }
    .swiper-button-prev,
    .swiper-button-next {
      display: none;
    }
  }
  ${breakpoint(`mobile`)} {
    .swiper-slide {
      width: 50%;
    }
  }
`;

const RelativeBoardCard = styled<FC<NewsProps>>(
  ({ newslist, isSwiper, isDate, img, pop, popInnerTit, ...props }) => {
    const date = new Date();
    const year = date.getFullYear();
    const month = `0${1 + date.getMonth()}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    const today = year + month + day;

    const [popupOpen, setPopupOpen] = useState(false);
    const [PopupTitle, setPopupTitle] = useState(``);
    const [PopupImg, setPopupImg] = useState(``);
    const [PopupImgYn, setPopupImgYn] = useState(``);
    const [PopupContents, setPopupContents] = useState(``);
    const [PopupLink, setPopupLink] = useState(``);
    const [PopupVideo, setPopupVideo] = useState(``);
    const [PopupSid, setPopupSid] = useState<PopupData | string | number>(``);

    const open = () => setPopupOpen(true);
    const close = () => setPopupOpen(false);

    return (
      <>
        {isSwiper ? (
          <SwiperCustom {...props}>
            <Swiper
              slidesPerView={4}
              breakpoints={{
                320: {
                  slidesPerView: 2,
                },
                641: {
                  slidesPerView: 3,
                },
                991: {
                  slidesPerView: 4,
                },
              }}
              navigation
              scrollbar={{ draggable: true }}
              autoplay={props.autoplay}
            >
              {newslist.map((row) => (
                <SwiperSlide key={row.id}>
                  {!pop ? (
                    <LinkSafe
                      to={row.link}
                      className="link-item"
                      state={{ boardCategoryCode: row.boardCategoryCode }}
                    >
                      <NewsImage>
                        {img ? (
                          <Image
                            className="card-img"
                            pcSrc={row.pcImage}
                            mobileSrc={row.mobileImage}
                          />
                        ) : (
                          <div
                            className="img-box"
                            css={`
                              background-image: url(${row.pcImage});
                            `}
                          />
                        )}
                      </NewsImage>
                      <NewsBody>
                        <Tit size="s4-1">
                          {row.title}
                          {today - dayjs(row.date).format(`YYYYMMDD`) <= 7 ? (
                            <NewText>new</NewText>
                          ) : null}
                        </Tit>
                        {isDate ? <NewsDate>{row.date}</NewsDate> : null}
                      </NewsBody>
                    </LinkSafe>
                  ) : (
                    <LinkButton
                      onClick={() => {
                        console.log(row.pcImage);
                        open();
                        setPopupTitle(row.title);
                        setPopupSid(row.popSid);
                        setPopupImg(row.pcImage);
                        setPopupContents(row.contents);
                        setPopupLink(row.link);
                        setPopupVideo(row.video);
                        setPopupImgYn(row.imgYn);
                      }}
                    >
                      <NewsImage>
                        {img ? (
                          <Image
                            className="card-img"
                            pcSrc={row.pcImage}
                            mobileSrc={row.mobileImage}
                          />
                        ) : (
                          <div
                            className="img-box"
                            css={`
                              background-image: url(${row.pcImage});
                            `}
                          />
                        )}
                      </NewsImage>
                      <NewsBody>
                        <Tit size="s4-1">
                          {row.title}
                          {today - dayjs(row.date).format(`YYYYMMDD`) <= 7 ? (
                            <NewText>new</NewText>
                          ) : null}
                        </Tit>
                      </NewsBody>
                    </LinkButton>
                  )}
                </SwiperSlide>
              ))}
            </Swiper>

            {pop && (
              <KoreaCooperationLayerPopup
                isOpen={popupOpen}
                PopTitle={PopupTitle}
                PopSid={PopupSid}
                onRequestClose={close}
                PopImg={PopupImg}
                PopContents={PopupContents}
                link={PopupLink}
                video={PopupVideo}
                popInnerTit={popInnerTit}
                PopupImgYn={PopupImgYn}
              />
            )}
          </SwiperCustom>
        ) : (
          <NewsCardLayout className="flex list-flex">
            {newslist.map((row) => (
              <li key={row.id}>
                <LinkSafe to={row.link} className="link-item">
                  <NewsImage>
                    {img ? (
                      <Image
                        className="card-img"
                        pcSrc={row.pcImage}
                        mobileSrc={row.mobileImage}
                      />
                    ) : (
                      <div
                        className="img-box"
                        css={`
                          background-image: url(${row.pcImage});
                        `}
                      />
                    )}
                  </NewsImage>
                  <NewsBody className="dec-wrap">
                    <Tit size="s4-1">
                      {row.title}
                      {today - dayjs(row.date).format(`YYYYMMDD`) <= 7 ? (
                        <NewText>new</NewText>
                      ) : null}
                    </Tit>
                    {isDate ? (
                      <NewsDate className="date">
                        {dayjs(row.date).format(`YYYY-MM-DD`)}
                      </NewsDate>
                    ) : null}
                  </NewsBody>
                </LinkSafe>
              </li>
            ))}
          </NewsCardLayout>
        )}
      </>
    );
  },
)``;
export default RelativeBoardCard;
